module.exports = __webpack_public_path__ + "img/backgroundWA.f9cebf24.jpg";